module.exports = __webpack_public_path__ + "static/media/models.c461c19a.svg";